/**
 * Content types used in our NPAW analytics data.
 *
 * @remarks
 * If the value is not provided we try to detect it via the supplied SourceType provided in ManifestConfig.type.
 */
export const NPAWContentType = {
  /**
   * The current content is a video on demand.
   *
   * @remarks
   * The player can detect this type automatically.
   *
   * Beware that the player may not be able to detect the difference between a video on demand and an audio on demand,
   * because the player itself does differentiate between these two types.
   */
  VOD: 'VoD',

  /**
   * The current content is a live stream of a 24/7 tv channel.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Live: 'Live',

  /**
   * The current content is a live stream of a sports event.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Event: 'Event',

  /**
   * The current content is an audiobook.
   *
   * @remarks
   * The client must specify this type manually.
   */
  Audiobook: 'Audiobook',

  /**
   * The current content is a radio stream.
   *
   * @remarks
   * The client must specify this type manually.
   */
  Radio: 'Radio',

  /**
   * The current content is a podcast.
   *
   * @remarks
   * The client must specify this type manually.
   */
  Podcast: 'Podcast',

  /**
   * The current content is music content provided by Deezer.
   *
   * @remarks
   * This type is not applicable for the HTML5 Foundation Player.
   */
  Music: 'Musik',

  /**
   * The current content is a FAST Channel.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  FAST: 'Fast',

  /**
   * The current content is a tts (Text To Speech) stream.
   *
   * @remarks
   * The player can detect this type automatically.
   * */
  TTS: 'TTS',
} as const;

/**
 * {@inheritDoc NPAWContentType:var}
 */
export type NPAWContentType = (typeof NPAWContentType)[keyof typeof NPAWContentType];
